import CatalogController from "./controllers/catalog-controller";
import WarningAuthController from "./controllers/warning-auth-controller";

export const showCatalogPopup = (logoData, catalogList) => {
  if (shopInfoData.message) {
    new WarningAuthController({message: shopInfoData.message}).show();
    return;
  }
  new CatalogController({logoData, catalogList}).show();
};
